import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	paper: {
		overflow: 'hidden',
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0
	},
	header: {
		padding: theme.spacing(1) / 2,
		paddingLeft: theme.spacing(2),
		backgroundColor: theme.palette.secondary.main,
		color: theme.palette.common.white,
		borderTopLeftRadius: theme.shape.borderRadius,
		borderTopRightRadius: theme.shape.borderRadius
	},
	hideButtonContainer: {
		display: 'flex',
		height: 48,
		marginBottom: theme.spacing(0.5),
		alignItems: 'center'
	}
}));
